import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Angular Material modules
import { MaterialModule } from '../../../material.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// DataTables
import { DataTablesModule } from 'angular-datatables';

// Components
import { TemplateCategoriesComponent } from './template-categories.component';
import { AddTemplateCategoryComponent } from './add-template-category/add-template-category.component';
import { EditTemplateCategoryComponent } from './edit-template-category/edit-template-category.component';
import { TemplateCategoryTreeComponent } from './template-category-tree/template-category-tree.component';
import { CategoryAssignmentDialogComponent } from './category-assignment-dialog/category-assignment-dialog.component';
import { TemplateOrganizationBrowserComponent } from './template-organization-browser/template-organization-browser.component';

// Services
import { TemplateCategoriesService } from './template-categories.service';

const routes = [
  {
    path: '',
    component: TemplateCategoriesComponent
  }
];

@NgModule({
  declarations: [
    TemplateCategoriesComponent,
    AddTemplateCategoryComponent,
    EditTemplateCategoryComponent,
    TemplateCategoryTreeComponent,
    CategoryAssignmentDialogComponent,
    TemplateOrganizationBrowserComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    
    // Angular Material
    MaterialModule,
    MatTreeModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatMenuModule,
    MatChipsModule,
    MatAutocompleteModule,
    
    // DataTables
    DataTablesModule
  ],
  providers: [
    TemplateCategoriesService
  ],
  exports: [
    TemplateCategoriesComponent
  ]
})
export class TemplateCategoriesModule { }